<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<NewIndexSiteLayout>
	<div class="container" ref="viewBox">
		<div id="content" class="content" ref="content">
			<Loading :is-loading="isListLoading"></Loading>
			<section class="section">
				<div class="ar-content">
					<div style="font-family: 黑体, SimHei; font-size: 24px;font-weight:normal;" v-html="taleDetail.title"></div>
					<div style="font-family: 黑体, SimHei; font-size: 16px;color:#9b9b9b;margin:12px 0;">
						<span>{{taleDetail.created_at}}</span>
						<span style="margin-left:20px;">{{$t('contentViews')}} {{views}}</span>
					</div>
					<div class="html-content" style="margin-top: 20px;" id="html-content" v-html="taleDetail.content"></div>
				</div>
			</section>
		</div>
		<Footer/>
	</div>
	</NewIndexSiteLayout>
</template>

<script>
import international_detail from './international_detail_controller';
export default international_detail;
</script>

<style src="@/assets/css/tale_detail.css" scoped></style>
